import React from 'react';
import moment from "moment";

const SocialMediaTableRow = ({ item, getLangTranslation, handleInputCheck }) => {
    const { text, activityDatetime, textAnalysisLabel, socialHistorId, imageUrl, appName, isKeyStroke } = item;
    return (
        <tr>
            <td className="v-middle">
                <div className="form-check">
                    <input
                        className="form-check-input text-nowrap"
                        type="checkbox"
                        id={socialHistorId}
                        name={socialHistorId}
                        checked={item?.isChecked}
                        onChange={handleInputCheck}
                    />
                </div>
            </td>
            <td className="v-middle">
                <div>
                    <span class="icon-wrap">
                        <img src={imageUrl} width={100} />
                    </span>
                    <span className='d-block fs-8'>
                        {appName}
                    </span>
                </div>
            </td>
            <td className="v-middle">{text}</td>
            <td className="v-middle text-nowrap">{moment(activityDatetime)?.format("MMMM DD, YYYY HH:mm:ss")}</td>
            <td className="v-middle text-nowrap">{isKeyStroke === 1 ? "KeyStroke" : "Social Media"}</td>
            <td className="v-middle">
                {
                    (textAnalysisLabel && textAnalysisLabel?.toLowerCase() !== 'safe') ? (
                        <div className='badge-pill warning text-nowrap'>{textAnalysisLabel}</div>
                    ) : ("---")
                }
            </td>
        </tr>
    )
}

export default SocialMediaTableRow